import { createContext, useContext } from "react";

/*
 * Concentration checks live in Shell state (they're raised from HP drops the
 * Roll20 / D&D Beyond handlers detect), but they belong — with the save prompts —
 * in the Current turn card, which Initiative renders. Shell is an ancestor of the
 * panel, so this context carries them down. Default is a safe empty value, so a
 * bare render of Initiative (the render-smoke test) works outside the provider.
 */
// syncSuspect: set when two systems held different HP for this PC as the check fired,
// so the drop may be a cross-source sync rather than real damage. A note only — the
// check still shows and still demands a save; this never suppresses it.
export interface ConcCheck { id: string; characterId: string; name: string; damage: number; dc: number; auras: string[]; syncSuspect?: string }
export interface ConcChecksApi { concChecks: ConcCheck[]; resolveConc: (check: ConcCheck, kept: boolean) => void }

const Ctx = createContext<ConcChecksApi | null>(null);
export const ConcChecksProvider = Ctx.Provider;
export const useConcChecks = (): ConcChecksApi => useContext(Ctx) ?? { concChecks: [], resolveConc: () => {} };
